<!--====== ABOUT PART START ======-->

<section id="about" class="about-area pt-80 pb-130">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="about-image mt-50 clearfix">
                    <div class="single-image float-left">
                        <img src="assets/images/about/one.jpg" alt="About" />
                    </div>
                    <!-- single image -->
                    <div data-aos-duration="3000" data-aos="fade-right" class="about-btn">
                        <a class="main-btn" href="#"
                            >± <span>100,000</span>hectares</a
                        >
                    </div>
                    <div class="single-image image-tow float-right">
                        <img src="assets/images/about/two.jpg" alt="About" />
                    </div>
                    <!-- single image -->
                </div>
                <!-- about image -->
            </div>
            <div class="col-lg-6">
                <div class="about-content mt-45">
                    <h4 class="about-welcome">About Us</h4>
                    <h3 class="about-title mt-10">It's about our company, how we started and our goals as a team</h3>
                    <p class="mt-20">
                        PT COCO NUSA KHATULISTIWA is an export trading company by exports local agricultural products, our main product is coconut derivatives and green bean coffee.
                    </p>
                    <p class="mt-2">
                        Founded in 2020, with the passion and commitment of the founder, Our business activities are focused on optimizing company values: Integrity, Commitment, Consistency and Responsibility.
                    </p>

                    <h5 class="about-title mt-20">Why Us?</h5>
                    <p class="mt-20">
                        Our quality and excellence are reflected in standard operational procedures we adopt at all stages of our processes and our people are responsible for every product.
                    </p>
                    <p class="mt-2">
                        We bring Indonesian the best quality of commodities directly through sustainable farming and trading practices from our farmers to the global market.
                    </p>

                    <!-- <p class="mt-4">
                        The commodities that we offer are:
                    </p>
                    <h3 class="mt-2">
                        COCONUT PRODUCT: Semi Husked, Coconut Fiber, Cocopeat and Desiccated Coconut.
                    </h3>
                    <h3 class="mt-2">
                        COFFEE PRODUCT: Robusta and Arabica Coffee.
                    </h3> -->
                    <!-- <a class="main-btn mt-25" href="#">learn more</a> -->
                </div>
                <!-- about content -->
            </div>
        </div>
        <!-- row -->
        <div class="row mt-100">
            <div data-aos="fade-left" class="col-lg-6 padding-0">
                <img
                    class="img-fluid"
                    src="/assets/images/about/mm.jpeg"
                    alt="..."
                />
            </div>
            <div data-aos="fade-right" class="col-lg-6 order-lg-first padding-0">
                <div class="h-100 text-center">
                    <div class="d-flex h-100">
                        <div
                            class="project-text w-100 my-auto text-center"
                        >
                            <h2 class="text-black">Vision</h2>
                            <p class="mb-0 mt-2 text-black-50 mx-4">
                                To become a leading export trading company by exporting local products from Indonesian Farmer and together we improve national economy.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div data-aos="fade-right" class="col-lg-6 padding-0">
                <img
                    class="img-fluid"
                    src="/assets/images/about/mision.jpeg"
                    alt="..."
                />
            </div>
            <div data-aos="fade-left" class="col-lg-6 padding-0">
                <div class="text-center h-100 project">
                    <div class="d-flex h-100">
                        <div
                            class="project-text w-100 my-auto text-center"
                        >
                            <h2 class="text-black">Mision</h2>
                            <p class="mb-0 mt-2 text-black-50 mx-4">
                                Provide trust and service to achieve customer satisfaction
                            </p>
                            <p class="mb-0 mt-0 text-black-50 mx-4">
                            Applying a quality management system to create best quality products
                            </p>
                            <p class="mb-0 mt-0 text-black-50 mx-4">
                            Creating network partnerships between companies and customers
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- container -->
</section>

<!--====== ABOUT PART ENDS ======-->
<style>
    #about {
        margin-top: -20px;
    }
    .bg-black {
        background: url("../assets/images/about/dots.jpg");
  background-repeat: no-repeat;
    }
    .order-lg-first {
    order: -1 !important;
  }
  .padding-0{
      padding-left: 0;
      padding-right: 0;
  }
  p{
      font-weight: 400;
      font-size: larger;
  }
</style>
